export function setBrowserTitle(to) {
  document.title = to?.meta?.title;
}
